import { Outlet, createFileRoute } from '@tanstack/react-router'
import { LoginPage } from '@/pages/login'
import { AppShell } from '@/components/shell/app-shell'
import { useSession } from '@/lib/auth-client'

export const Route = createFileRoute('/_app')({
	component: AuthenticatedLayout,
})

function AuthenticatedLayout() {
	const { data: session, isPending } = useSession()

	if (isPending) {
		return <BootSplash />
	}

	if (!session?.user) {
		return <LoginPage />
	}

	return (
		<AppShell user={session.user as never}>
			<Outlet />
		</AppShell>
	)
}

function BootSplash() {
	return (
		<div className="flex h-svh w-full items-center justify-center bg-background" dir="rtl">
			<div className="flex flex-col items-center gap-4 text-muted-foreground">
				<div className="size-12 animate-spin rounded-full border-2 border-primary/20 border-t-primary" />
				<p className="text-sm">جارٍ التحميل...</p>
			</div>
		</div>
	)
}
